import { ReactElement } from 'react';
import { ArticlePermissions } from '../../models';
import { LoanWaiverModal } from './LoanWaiver/LoanWaiverModal';
import { LockedArticleModal } from './LockedArticle';
import { ArticleLimitModal } from './ArticleLimit';
import { AccessStatus } from '../../services/dtos/article/article.dto';

export interface RestrictedContentModalProps {
  onConfirm: () => void;
  articlePermissions: ArticlePermissions;
}

const RestrictedArticleModal = ({
  onConfirm,
  articlePermissions,
}: RestrictedContentModalProps): ReactElement | null => {
  switch (articlePermissions.accessStatus) {
    case AccessStatus.granted:
      return null;
    case AccessStatus.loanWaiverConfirmRequired:
      return <LoanWaiverModal onConfirm={onConfirm} articlePermissions={articlePermissions} />;
    case AccessStatus.privateAccessRequired:
    case AccessStatus.subscriptionRequired:
      return <LockedArticleModal articlePermissions={articlePermissions} />;
    case AccessStatus.quotaExceeded:
    case AccessStatus.quotaUsageConfirmRequired: {
      if (!articlePermissions.quota) {
        return null;
      }
      return (
        <ArticleLimitModal
          onConfirm={onConfirm}
          quota={articlePermissions.quota}
          isPrivate={articlePermissions.content.isPrivate}
        />
      );
    }
    default:
      return null;
  }
};

export default RestrictedArticleModal;
